// /app/frontend/src/features/choral-intelligence/ChoralRecommendationCard.jsx
import React from "react";
import RecommendationExplanation from "./RecommendationExplanation";
import RecommendationDetails from "./RecommendationDetails";

function statusLabel(status) {
  const labels = {
    verified: "Verified",
    editor_reviewed: "Editorial Reviewed",
    ai_reviewed: "AI Reviewed",
    draft: "Draft",
    archived: "Archived",
  };
  return labels[status] || "Catalog Record";
}

function toPercent(value) {
  if (typeof value !== "number" || Number.isNaN(value)) return "—";
  return `${Math.round(value * 100)}%`;
}

export default function ChoralRecommendationCard({
  recommendation,
  onOpenWork,
}) {
  const { work, ranking, explanation } = recommendation;

  return (
    <article
      className="ci-card"
      data-testid={`ci-card-${work.id}`}
      aria-labelledby={`ci-title-${work.id}`}
    >
      <header className="ci-card__header">
        <div>
          <h2
            id={`ci-title-${work.id}`}
            className="ci-card__title"
            data-testid={`ci-title-${work.id}`}
          >
            {work.title}
          </h2>
          <p
            className="ci-card__composer"
            data-testid={`ci-composer-${work.id}`}
          >
            {work.composer || "Anonymous"}
          </p>
        </div>
        <span
          className={`ci-card__status ci-card__status--${work.verification_status}`}
          data-testid={`ci-status-${work.id}`}
        >
          {statusLabel(work.verification_status)}
        </span>
      </header>

      <div
        className="ci-card__score-pill"
        data-testid={`ci-total-${work.id}`}
      >
        Fit
        <strong>{toPercent(ranking?.total_score)}</strong>
      </div>

      <RecommendationExplanation explanation={explanation} />

      <RecommendationDetails ranking={ranking} />

      <footer className="ci-card__footer">
        <span
          className="ci-card__catalog-id"
          data-testid={`ci-catalog-id-${work.id}`}
          style={{
            fontFamily: '"IBM Plex Mono", monospace',
            fontSize: "0.75rem",
            color: "var(--li-text-secondary, #5C5450)",
            letterSpacing: "0.06em",
          }}
        >
          {work.id}
        </span>
        {onOpenWork && (
          <button
            type="button"
            className="ci-card__primary-action"
            onClick={() => onOpenWork(work)}
            data-testid={`ci-open-work-${work.id}`}
          >
            Open in Repertoire
          </button>
        )}
      </footer>
    </article>
  );
}
